import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Page from "../../components/general/page";
import AdvancedPreview from "../../components/general/advancedPreview";
import PreCogDetailPage from "../../components/preCog/detail/index";
import ReasonsModal from "../../components/preCog/detail/reasonsModal";
import { getCurrencyList } from "../../store/actions/currency";
import Spinner from "../../components/general/spinner";
import { clearInvoiceDetail, getInvoiceDetail } from "../../store/actions/precog";
import { FormattedMessage } from "react-intl";
import JsonRegistration from "../../assets/json/jsonRegistration.json";
/* import { useCallbackPrompt } from "../../customHooks/useCallbackPrompt";
import DialogBox from "../../components/general/dialogBox";
*/

const PreCogDetail = ({ isCreate, pageRef }) => {
  // la form prelevata dal json per la creazione manuale
  const [drafIdByUrl, setDrafIdByUrl] = useState(null);
  const [formByReason, setFormByReason] = useState(null);
  const [isFromAccountantPage, setIsFromAccountantPage] = useState(false);
  const [reason, setReason] = useState(null);
  const [jsonManualReason, setJsonManualReason] = useState(null);
  const reasonDetail = useSelector((state) => state?.precog?.invoiceDetail?.data?.reasonId);
  const source = useSelector((state) => state.precog.invoiceDetail?.data?.source);
  const location = useLocation();
  const isFromRegistration = location?.state?.isFromRegistration;
  const queryUrl = new URLSearchParams(location.search);
  const backUrlLink = queryUrl.get("model");
  const isGoBack = location?.state?.goBack;
  const isFromRisconti = location?.state?.isFromRisconti;
  /**
   * BEGIN TODO: da rimuovere postDemo. Per capire se voglio o meno header e sidebar
   */
  const embedParameter = new URLSearchParams(location.search).get("embed");
  /**
    * END TODO: da rimuovere postDemo
    */

  /**
   * se ho in location lo state goBack allora torno semplicemente indietro
   * navigate(-1);
   *
   */

  /*
  const [showDialog, setShowDialog] = useState(true);
  const [showPrompt, confirmNavigation, cancelNavigation] =
  useCallbackPrompt(showDialog);
  */

  const dispatch = useDispatch();
  /** al momento non tutte le reasons di bank_payment sono attive Nell'array quelle visibili */
  // const reasonsActive = ["RF1", "RAC1", "PF1", "PAF1", "CG1", "RG1"];
  const reasonsActive = ["FE1", "FE4", "FE401", "FE5", "FE8", "FE9", "FE10", "CO1", "FA1", "FA3", "FA4", "FA401", "FA5", "FA7", "FA8", "RG1", "CG1", "RF1", "PF1", "MG1"];

  const getData = () => {
    setJsonManualReason(JsonRegistration);
  };

  useEffect(() => {
    if (!isCreate) {
      setDrafIdByUrl(location.pathname.split("precog-detail/")[1]);
    }
    /** dato che in registrazione manuale si può cambiare la currency,
     *  devo avere la lista disponibile */
    dispatch(getCurrencyList());
    getData();

    return () => {
      dispatch({ type: "CLEAR_CURRENCY_LIST" });
    };
  }, [location.pathname]);

  useEffect(() => {
    if (!drafIdByUrl) return undefined;
    /** Per evitare che la chiamata scatti 2 volte */
    dispatch(getInvoiceDetail(drafIdByUrl));
    return () => {
      dispatch(clearInvoiceDetail());
    };
  }, [drafIdByUrl]);

  useEffect(() => {

    if (!jsonManualReason) return;

    if (isCreate || reason) {
      setFormByReason(jsonManualReason?.[reason]);
    } else {
      // if (source === "MANUAL"){
      // verifico se c'è la reason associata ad un oggetto del json form
      setFormByReason(jsonManualReason?.[reasonDetail]);
      // }
    }
  }, [reason, isCreate, reasonDetail, jsonManualReason]);

  let searchParams = `model=${queryUrl.get("model")}`;

  for (const param of queryUrl.keys()) {
    if (param !== "model" && param !== "from") {
      searchParams += `&${param}=${queryUrl.get(param)}`;
    }
  }
  searchParams += `&documentId=${drafIdByUrl}`;

  /** TODO:: è normale che tornando indietro da dettaglio contabile partendo da report bilancio
   * si torni alla pagina iniziale dei report e non alla pagina precedente con il dettaglio esploso?
   * Nel caso basta passare state.goBack a true e torna semplicemente indietro di 1.
   */

  return !source && !isCreate ? (
    <Spinner
      size="large"
      tip={
        <span>
          <FormattedMessage id="generic.loading1" /> <br /> <FormattedMessage id="generic.loading2" />
        </span>
      }
    />
  ) : (
    <Page
      pageRef={pageRef}
      title={"Prima nota"}
      activePage="/preCog"
      backText={backUrlLink || isGoBack ? "Torna al report" : "Torna alla lista"}
      isFromAccountantPage={isFromAccountantPage}
      backUrl={backUrlLink ? `/reports?${searchParams}` : isGoBack || isFromRisconti ? -1 : "/precog"}
      className={"contentStructure transparent " + (embedParameter === "" ? "embed" : "")}
      subClassName="pageCss"
    >
      {isCreate && !reason ? (
        <ReasonsModal reasonsActive={reasonsActive} setReason={setReason} />
      ) : source === "DOC" ? (
        <AdvancedPreview style={{ height: "calc(100vh - 235px)", backgroundColor: "#FFF" }}>
          <PreCogDetailPage
            reasonsActive={reasonsActive}
            createReason={reason}
            setReason={setReason}
            isCreate={isCreate}
            backUrlLink={backUrlLink ? `/reports?${searchParams}` : -1}
            isFromRegistration={isFromRegistration}
            formByReason={formByReason}
            isFromAccountantPage={isFromAccountantPage}
            setIsFromAccountantPage={setIsFromAccountantPage}
          />
        </AdvancedPreview>
      ) : (
        <PreCogDetailPage
          reasonsActive={reasonsActive}
          createReason={reason}
          setReason={setReason}
          isCreate={isCreate}
          backUrlLink={backUrlLink ? `/reports?${searchParams}` : -1}
          isFromRegistration={isFromRegistration}
          formByReason={formByReason}
          isFromAccountantPage={isFromAccountantPage}
          setIsFromAccountantPage={setIsFromAccountantPage}
        />
      )}

      {/*
                                                 _ _
                                                | | |
  _ __   ___  _ __       ___ __ _ _ __   ___ ___| | | __ _ _ __ ___
 | '_ \ / _ \| '_ \     / __/ _` | '_ \ / __/ _ \ | |/ _` | '__/ _ \
 | | | | (_) | | | |   | (_| (_| | | | | (_|  __/ | | (_| | | |  __/
 |_| |_|\___/|_| |_|    \___\__,_|_| |_|\___\___|_|_|\__,_|_|  \___|
      <DialogBox
        setShowDialog={setShowDialog}
        showDialog={showPrompt}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
      />
    */}
    </Page>
  );
};

export default PreCogDetail;
